import { render, staticRenderFns } from "./page-banner.vue?vue&type=template&id=4624dfe4"
import script from "./page-banner.vue?vue&type=script&lang=js"
export * from "./page-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports